import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user.service';

@Component({
    selector: 'app-cancel-subsciption',
    templateUrl: './cancel-subsciption.component.html',
    styleUrl: './cancel-subsciption.component.scss',
    standalone: false
})
export class CancelSubsciptionComponent {
  subscription_date: any;
  UUID: any;
  processing: boolean = false;
  subscriptionPlan: any;
  subscription_end_date: string = '';

  constructor(
    private dialogRef: MatDialogRef<CancelSubsciptionComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    public userService: UserService,
  ) {
    
    this.subscriptionPlan = data.SubscriptionPlan;
    this.UUID = data.UUID;
    this.subscription_date = data.subscription_end_date;
    this.subscription_end_date = this.formatDate(this.subscription_date);
  }

  ngOnInit() {}

  formatDate(dateStr: string): string {
    const date = new Date(dateStr);
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
    const formatted = date.toLocaleDateString('en-US', options);
    const day = date.getDate();
    const suffix = this.getDaySuffix(day);
    return formatted.replace(String(day), day + suffix);
  }

  getDaySuffix(day: number): string {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

  Confirm() {
    this.processing = true;
    this.userService.cancelSubscription(this.UUID).subscribe((res) => {
      this.processing = false;
      this.dialogRef.close('cancelDialog');
    }, (err) => {
      console.error('Cancellation failed', err);
    });
  }

  close() {
    this.dialogRef.close('cancelDialog');
  }
}
